import React from 'react';
import { Zoom } from 'react-reveal';

const AdmissionTeacher = ({ tea }) => {
    const { title, teacherName, profile } = tea;
    return (
        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
            <Zoom>
                <div className="shadow-lg d-flex align-items-center rounded p-2" style={{ minHeight: '90px' }}>
                    <div className="teacher-logo">
                        <img src={profile} alt={teacherName} className='img-fluid rounded-pill' style={{ height: '50px', width: '50px' }} />
                    </div>
                    <div className="teacher-info ms-2">
                        <h5 className='fs-5'>{teacherName}</h5>
                        <p className='text-secondary'>{title}</p>
                    </div>
                </div>
           </Zoom>
        </div>
    );
};

export default AdmissionTeacher;